import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

function ColoredProgress({
  className,
  value,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  const getProgressColor = (progress: number) => {
    // Apply easing to reach green around 70-75%
    const easedProgress = Math.min(100, progress * 1.33);

    // Red at 0%, green (#6A943D) at ~75%
    const red = Math.round(220 - (easedProgress / 100) * 114); // 220 -> 106
    const green = Math.round(53 + (easedProgress / 100) * 95); // 53 -> 148
    const blue = Math.round(53 + (easedProgress / 100) * 8); // 53 -> 61

    return `rgb(${red}, ${green}, ${blue})`;
  };

  const progressValue = value || 0;
  const indicatorColor = getProgressColor(progressValue);

  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary rounded-full h-full w-full flex-1 transition-all"
        style={{
          transform: `translateX(-${100 - progressValue}%)`,
          backgroundColor: indicatorColor,
        }}
      />
    </ProgressPrimitive.Root>
  );
}

export { ColoredProgress };
